/* Progressive enhancement for this promo only. Native Shopify form POST remains the no-JS fallback. */
if (!customElements.get('up-texas-promo')) {
  customElements.define('up-texas-promo', class extends HTMLElement {
    connectedCallback() {
      if (this.boundSubmit) return;
      this.boundSubmit = this.onSubmit.bind(this);
      this.saleEnd = Date.parse(this.dataset.saleEndsAt);
      this.countdown = this.querySelector('[data-countdown]');
      if (this.countdown && Number.isFinite(this.saleEnd)) {
        this.updateCountdown();
        if (!this.saleHasEnded()) this.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
      }
      this.addEventListener('submit', this.boundSubmit);
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target.classList.contains('up-tx__hero')) this.classList.toggle('up-tx--past-hero', !entry.isIntersecting);
          if (entry.target.classList.contains('up-tx__offers')) this.classList.toggle('up-tx--at-offers', entry.isIntersecting);
        });
      });
      this.observer.observe(this.querySelector('.up-tx__hero'));
      this.observer.observe(this.querySelector('.up-tx__offers'));
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.boundSubmit);
      this.boundSubmit = null;
      this.observer?.disconnect();
      clearInterval(this.countdownInterval);
    }

    saleHasEnded() {
      return Number.isFinite(this.saleEnd) && Date.now() >= this.saleEnd;
    }

    updateCountdown() {
      const seconds = Math.max(0, Math.ceil((this.saleEnd - Date.now()) / 1000));
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      for (const [unit, value] of Object.entries(values)) this.countdown.querySelector(`[data-time="${unit}"]`).textContent = String(value).padStart(2, '0');
      this.countdown.hidden = false;
      if (this.saleHasEnded()) {
        clearInterval(this.countdownInterval);
        this.countdown.hidden = true;
        this.querySelector('[data-sale-ended]').hidden = false;
        this.querySelectorAll('.up-tx__buy').forEach(button => { button.disabled = true; });
      }
    }

    async onSubmit(event) {
      const form = event.target;
      if (!form.matches('.up-tx__form')) return;
      event.preventDefault();
      if (this.saleHasEnded()) { this.updateCountdown(); return; }
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled || !form.reportValidity()) return;
      const label = button.querySelector('[data-button-label]');
      const error = form.querySelector('.up-tx__form-error');
      const originalLabel = label.textContent;
      error.hidden = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Adding to cart…';
      let added = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        const result = await response.json();
        if (!response.ok) {
          error.textContent = typeof result.description === 'string' ? result.description : 'This gift card could not be added. Please try again.';
          error.hidden = false;
          return;
        }
        added = true;
        label.textContent = 'Opening your cart…';
        window.location.assign(this.dataset.cartUrl);
      } catch {
        error.replaceChildren(document.createTextNode('We couldn’t confirm whether the gift card was added. '));
        const link = document.createElement('a');
        link.href = this.dataset.cartUrl;
        link.textContent = 'Check your cart';
        error.append(link, document.createTextNode(' before trying again.'));
        error.hidden = false;
      } finally {
        if (!added) {
          button.disabled = this.saleHasEnded();
          button.removeAttribute('aria-busy');
          label.textContent = originalLabel;
        }
      }
    }
  });
}
